import { Observable } from 'rxjs';
import { ApiUrl } from '../api-core/api-constants';
import { NoContent, PatchObject } from '../api-core/api-core.types';
import {
  apiDelete,
  apiGet,
  apiPatch,
  apiPost,
} from '../api-core/api-request';
import apiItemHookFactory from '../api-core/utility-factories/api-item-hook-factory';
import apiRequestHookFactory from '../api-core/utility-factories/api-request-hook-factory';
import apiResourceHookFactory from '../api-core/utility-factories/api-resource-hook-factory';
import { apiRedux } from '../api-redux';
import {
  AssignedProduct,
  AssignedProductLite,
  AssignProductCustomImgReq,
  AssignProductImageRtn,
  AssignProductReceiptImgReq,
  AssignProductReq,
  AssignProductRtn,
  AssignV1ProductReq,
  RepairAssignedProduct,
  AssignProductReqBlank,
} from './api-product-assignment.types';

export const useAssignedProductsLite = apiResourceHookFactory(
  apiRedux.assignedProductsLite,
  (): Observable<AssignedProductLite[]> =>
    apiGet<AssignedProductLite[]>(ApiUrl.ASSIGNED_PRODUCTS, {
      urlParams: { detail: 'low' },
    })
);

export const useAssignedProductsRepair = apiResourceHookFactory(
  apiRedux.repairAssignedProducts,
  (): Observable<RepairAssignedProduct[]> =>
    apiGet<RepairAssignedProduct[]>(ApiUrl.REPAIR_ASSIGNED_PRODUCTS)
);

export const useAssignedProduct = apiItemHookFactory(
  apiRedux.assignedProduct,
  (id: number): Observable<AssignedProduct> =>
    apiGet<AssignedProduct>(`${ApiUrl.ASSIGNED_PRODUCTS}/${id}`)
);

export const useAssignProduct = apiRequestHookFactory(
  apiRedux.assignProductV1,
  (
    data: AssignProductReq | AssignV1ProductReq
  ): Observable<AssignProductRtn> =>
    apiPost<AssignProductRtn>(ApiUrl.ASSIGNED_PRODUCTS_V1, data)
);
export const useAssignProductBlank = apiRequestHookFactory(
  apiRedux.assignProductV1Blank,
  (data: AssignProductReqBlank): Observable<AssignProductRtn> =>
    apiPost<AssignProductRtn>(ApiUrl.ASSIGNED_PRODUCTS_V1, data)
);

export const useDeleteAssignedProduct = apiRequestHookFactory(
  apiRedux.deleteAssignedProduct,
  (id: number): Observable<NoContent> =>
    apiDelete<NoContent>(`${ApiUrl.ASSIGNED_PRODUCTS}/${id}`)
);

export const useSetAssignedProductReceiptImg = apiRequestHookFactory(
  apiRedux.assignProductReceiptImg,
  ({
    id,
    data,
  }: PatchObject<AssignProductReceiptImgReq>): Observable<AssignProductImageRtn> =>
    apiPost<AssignProductImageRtn>(
      `${ApiUrl.ASSIGNED_PRODUCTS}/${id}/update-image`,
      data
    )
);

export const useSetAssignedProductCustomImg = apiRequestHookFactory(
  apiRedux.assignProductCustomImg,
  ({
    id,
    data,
  }: PatchObject<AssignProductCustomImgReq>): Observable<AssignProductImageRtn> =>
    apiPost<AssignProductImageRtn>(
      `${ApiUrl.ASSIGNED_PRODUCTS}/${id}/user-product-image`,
      data
    )
);

export const useUpdateAssignedProduct = apiRequestHookFactory(
  apiRedux.assignProduct,
  ({
    id,
    data,
  }: PatchObject<AssignProductReq>): Observable<AssignedProduct> =>
    apiPatch<AssignedProduct>(
      `${ApiUrl.ASSIGNED_PRODUCTS}/${id}`,
      data
    )
);
